import { Box } from "@chakra-ui/react";
import { MainContent, PageHeaderStructure } from "../../components/Layout";
import InfoButton from "../../components/Dashboard/InfoButton";

// Layout raso comum aos 6 dashboards (era 1 Tabs só, virou 1 rota por
// painel — cada um ganha a própria entrada no grupo "Dashboards" da
// sidebar, em vez de disputar espaço numa TabList horizontal).
export default function DashboardPage({ title, subtitle, info, children }) {
  return (
    <MainContent>
      <PageHeaderStructure title={title} subtitle={subtitle}>
        {info && <InfoButton title={title}>{info}</InfoButton>}
      </PageHeaderStructure>
      <Box mt="24px">{children}</Box>
    </MainContent>
  );
}
